export const MixpanelObject = {
  BUTTON: 'Button',
  ACCORDION: 'Accordion',
  FORM: 'Form',
  PAGE: 'Page'
};

export const MixpanelAction = {
  CLICK: 'Click',
  HOVER: 'Hover',
  SUBMIT: 'Submit',
  ON_CHANGE: 'On Change',
  VIEW: 'View (Impression)'
};
